import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'
Vue.use(ViewUI)

import './assets/swiper.min.css'

Vue.prototype.$Message.config({
  top: 150,
  duration: 5
});

import mixins from './utils/mixins'
Vue.mixin(mixins);

import './assets/common.scss'

Vue.config.productionTip = false

router.afterEach(() => {
  document.body.scrollTop = 0
  document.documentElement.scrollTop = 0
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
